import {useEffect} from 'react';

export function useEditorPrefetchLayoutMobileModules(): void {
  useEffect((): void => {
    void prefetchLayoutItemModules();
  }, []);

  const prefetchLayoutItemModules = async (): Promise<void> => {
    await import(/* webpackPrefetch: true */ '@Panels/poster-editor-item-layout-panel');
    await import(/* webpackPrefetch: true */ '@Panels/poster-editor-layout-item-font-panel');
    await import(/* webpackPrefetch: true */ '@Panels/poster-editor-item-font-style-panel');
    await import(/* webpackPrefetch: true */ '@Panels/poster-editor-item-style-2-panel');
    await import(/* webpackPrefetch: true */ '@Panels/poster-editor-item-font-size-panel');
    await import(/* webpackPrefetch: true */ '@Panels/poster-editor-layout-fill-panel');
    await import(/* webpackPrefetch: true */ '@Panels/poster-editor-text-outline-panel');
    await import(/* webpackPrefetch: true */ '@Panels/poster-editor-item-alignment-panel');
    await import(/* webpackPrefetch: true */ '@Panels/poster-editor-layout-item-spacing-panel');
    await import(/* webpackPrefetch: true */ '@Panels/poster-editor-item-background-panel');
    await import(/* webpackPrefetch: true */ '@Panels/poster-editor-layout-item-border-panel');
    await import(/* webpackPrefetch: true */ '@Panels/poster-editor-item-date-styles-panel');
    await import(/* webpackPrefetch: true */ '@Panels/poster-editor-menu-item-icon-styles-panel');
    await import(/* webpackPrefetch: true */ '@Panels/poster-editor-item-line-height-panel');
    await import(/* webpackPrefetch: true */ '@Panels/poster-editor-item-letter-spacing-panel');
  };
}
